import type { AdvisingAndCoachingPatch, AdvisingAndCoachingUpdateResponse } from "@profile-service-types/index.ts";
import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { profileServiceRequest } from "@/services/utils";

type UsePatchProfileAdvisingAndCoachingArgs = {
  payload: AdvisingAndCoachingPatch[];
};

export const usePatchProfileAdvisingAndCoaching = (
  useMutationOptions?: UseMutationOptions<
    AdvisingAndCoachingUpdateResponse,
    Error,
    UsePatchProfileAdvisingAndCoachingArgs
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation<AdvisingAndCoachingUpdateResponse, Error, UsePatchProfileAdvisingAndCoachingArgs>({
    mutationFn: async ({ payload }) => {
      const response = await profileServiceRequest({
        method: "patch",
        url: "/profiles/advising_and_coaching/",
        payload,
      });
      return response?.data?.data;
    },
    onSuccess: async (data, { payload }) => {
      await queryClient.invalidateQueries({
        queryKey: ["fetchGetAdvisingAndCoaching"],
      });
    },
    ...useMutationOptions,
  });
};
